import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

/* eslint-disable */
import nl from "vuetify/src/locale/nl.ts";
import en from "vuetify/src/locale/en.ts";
import de from "vuetify/src/locale/de.ts";
import fr from "vuetify/src/locale/fr.ts";
import es from "vuetify/src/locale/es.ts";
import se from "vuetify/src/locale/sv.ts";
import it from "vuetify/src/locale/it.ts";
import da from "@/locale/da";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#5b8ff5",
        secondary: "#424242",
        accent: "#f6f9fb",
        error: "#ff5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
    },
  },
  icons: {
    iconfont: "mdi",
  },
  lang: {
    locales: { nl, en, de, fr, es, se, da, it },
    current: "nl", // текущий язык интерфейса
  },
});
